import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const TRIMLEFT = () => {
  return (
    <CardSection id="TRIMLEFT" title="TRIMLEFT">
      <Paragraph>
        문자열의 왼쪽 끝의 공백을 제거한 문자열을 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>TRIMLEFT(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 트리밍하려는 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>TRIMLEFT(`Column`)</Paragraph>
        <Img src="computeTrimLeft" />
      </ListSection>
    </CardSection>
  );
};
